module.exports = __webpack_public_path__ + "static/media/chevron_down.a5772827.svg";